//Third party components
import React from 'react';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';

// Shared components
import { LineLoader, LoadingSpinner,PamLayoutGrid, Modal } from '@timmons-group/shared-react-components';

// Hooks
import { useGet, useAuth } from '@timmons-group/shared-react-components/hooks';
import { useLayout } from '../../hooks/useLayout';
import { hasPermission } from '../../helpers';
import { useNavigate } from 'react-router-dom';
import { ACLS } from '../../constants';

// Constants
const ModalMode = {
  View: 'VIEW',
};

const ModalAction = {
  View: 'VIEW',
  Close: 'CLOSE',
  Reset: 'RESET',
};

// Reducers
const initialModalState = {
  modalIsOpen: false,
  modalTitle: '',
  modalText: '',
  okLabel: 'OK',
  modalMode: null,
  rowData: null,
};

const modalReducer = (state, action) => {
  const rowData = { ...action?.payload?.rowData };
  switch (action.type) {
    case ModalAction.View:
      return { modalIsOpen: true, modalText: `NOT IMPLEMENTED - View ${rowData?.name}`, modalMode: ModalMode.View, rowData };
    default:
      throw new Error('This mode is not supported.');
  }
}

const UnitsGrid = () => {
  const [units, unitsLoading] = useGet('api/unit/all', []);
  const [layout, layoutLoading] = useLayout('unit', 'unitList');
  const [modalState, modalDispatch] = React.useReducer(modalReducer, initialModalState);
  const { authState } = useAuth();

  // props.acl is a backdoor to allow storybook stories to pass in acls
  const acl = authState?.user?.acl;
  const nav = useNavigate();

  const handleViewClick = (row) => {
    nav(`/units/${row.id}`);
  };

  let actionList = [];
  if (hasPermission(ACLS.SEE_UNITS, acl)) {
    actionList.push({
      label: 'VIEW',
      order: 0,
      clickHandler: handleViewClick
    });
  }

  const actionData = [{
    order: 0,
    actionList,
    label: 'Actions',
  }];

  const handleModalAffirmative = () => {
    try {
      modalDispatch({ type: ModalAction.Close });
    } catch (error) {
      console.error(error);
    } finally {
      // Ensure that we clear the data
      modalDispatch({ type: ModalAction.Reset });
    }
  }

  const handleModalCancel = () => {
    modalDispatch({ type: ModalAction.Reset });
  }

  const renderUnits = () => {
    if (unitsLoading) {
      return <LineLoader message="Loading Units..." color="secondary" />;
    }

    if (!units || !units.length) {
      return <p>No Units found</p>;
    }

    return unitsLoading || layoutLoading ?
      (<Box>
        <LineLoader message="Loading All Units..." color="secondary" />
      </Box>)
      :
      (<Box
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        mt={2}
        minHeight="500px"
        width="100%"
      >
        <PamLayoutGrid
          actions={actionData}
          data={units}
          getRowId={(row) => row.id}
          initialSortColumn={'unitName'}
          initialSortDirection={'asc'}
          layout={layout}
          autoHeight
          disableSelectionOnClick
          density="compact"
        />
      </Box>)
  };

  return (
    <>
      {renderUnits()}
      <Modal
        okLabel={modalState.okLabel || 'Confirm'}
        cancelLabel="Cancel"
        title={modalState.modalTitle}
        onOk={handleModalAffirmative}
        onCancel={handleModalCancel}
        handleClose={handleModalCancel}
        showX={true}
        open={modalState.modalIsOpen}
        hideActions={false}
        hideCancel={false}
      >
        <Typography gutterBottom>
          {modalState.modalText}
        </Typography>
      </Modal>
    </>
  );
}

export default UnitsGrid;
